import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { useDeleteFeedbackType } from '../hooks/useDeleteFeedbackType';
import type { FeedbackType } from '../types/feedbackType.types';

interface FeedbackTypeDeleteConfirmationProps {
  feedbackType: FeedbackType | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function FeedbackTypeDeleteConfirmation({
  feedbackType,
  open,
  onOpenChange,
}: FeedbackTypeDeleteConfirmationProps) {
  const { mutate, isPending } = useDeleteFeedbackType();

  function handleConfirm() {
    if (!feedbackType) return;
    mutate(feedbackType.id, { onSuccess: () => onOpenChange(false) });
  }

  const description = feedbackType
    ? `"${feedbackType.name}" will be permanently removed. This action cannot be undone.`
    : '';

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete feedback type?"
      description={description}
      confirmLabel="Delete"
      confirmVariant="destructive"
      isPending={isPending}
      pendingLabel="Deleting..."
      onConfirm={handleConfirm}
    />
  );
}
